var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMypage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 9,
    r: 4,
    stroke: "#999",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#999",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.5 21a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v2h-18v-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypage);
export default __webpack_public_path__ + "static/media/mypage.0c0708c9a92fe18ec069d634e256c90d.svg";
export { ForwardRef as ReactComponent };